import { getWujiCompInstance } from '@/utils/comps-loader';
import { platformBuiltinModules } from '../platform-builtin-modules';
export const presets = [
    'vue',
    'lodash',
    'axios',
    'dayjs',
    'ant-design-vue',
    'crypto',
    'ajv',
    'Buffer',
    'qs',
    'tdesign-vue-next',
    ...Object.keys(platformBuiltinModules),
    '@wujibase/wuji',
    '@wujibase/wuji-flow',
    '@wujibase/wuji-upload',
    '@wujibase/wuji-data',
];
class PresetLoader {
    presetHandlers = new Map();
    registerPreset(presetNames, handler) {
        presetNames.forEach((presetName) => {
            this.presetHandlers.set(presetName, handler);
        });
    }
    async load(presets) {
        const uniqueHandlers = new Set();
        presets.forEach((preset) => {
            const handler = this.presetHandlers.get(preset);
            if (handler) {
                uniqueHandlers.add(handler);
            }
        });
        const loadingTasks = Array.from(uniqueHandlers).map(async (handler) => {
            try {
                await handler();
            }
            catch (error) {
                throw error;
            }
        });
        await Promise.all(loadingTasks);
    }
}
const presetLoader = new PresetLoader();
presetLoader.registerPreset(['vue', 'ant-design-vue', 'tdesign-vue-next'], async () => {
    const wujiComp = getWujiCompInstance();
    const { moduleManage } = wujiComp;
    if (!moduleManage.webpackExternals?.includes('vue3')) {
        return moduleManage.loadVue3Dependencies();
    }
});
for (const [id] of Object.entries(platformBuiltinModules)) {
    presetLoader.registerPreset([id], () => Promise.resolve());
}
presetLoader.registerPreset(['react', 'antd', 'react-dom'], async () => {
    const wujiComp = getWujiCompInstance();
    const { moduleManage } = wujiComp;
    if (!moduleManage.webpackExternals?.includes('React')) {
        return moduleManage.loadReactDependencies();
    }
});
export default presetLoader;
